// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__dIRNN","errorMessageWrapper":"errorMessageWrapper__Vz6Sw","be.api.auth.login-failed-pw":"be.api.auth.login-failed-pw__wXYIh","loginFailedErrorMessagePWEmpty":"loginFailedErrorMessagePWEmpty__uoKgQ","loginButton":"loginButton__ikCAA","onyx":"onyx__IwehG","regFormWrapper":"regFormWrapper__OPYkt","foe":"foe__r0vMU","herocity":"herocity__GHNLb","village":"village__ropTg","loginForm":"loginForm__XSEIo"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"wrapper\":\"wrapper__dIRNN\",\"errorMessageWrapper\":\"errorMessageWrapper__Vz6Sw\",\"be.api.auth.login-failed-pw\":\"be.api.auth.login-failed-pw__wXYIh\",\"loginFailedErrorMessagePWEmpty\":\"loginFailedErrorMessagePWEmpty__uoKgQ\",\"loginButton\":\"loginButton__ikCAA\",\"onyx\":\"onyx__IwehG\",\"regFormWrapper\":\"regFormWrapper__OPYkt\",\"foe\":\"foe__r0vMU\",\"herocity\":\"herocity__GHNLb\",\"village\":\"village__ropTg\",\"loginForm\":\"loginForm__XSEIo\"}";
        // 1787130556872
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  